<template>
<svg @mouseover="isHover=true" @mouseout="isHover=false"
   version="1.1"
   id="svg1825"
   xml:space="preserve"
   :width="width"
   :height="height"
   viewBox="1 1 72 72"
   sodipodi:docname="annotated biblography-button.ai"
   inkscape:version="1.1 (ce6663b3b7, 2021-05-25)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs6"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath16"><path
         d="M 0,56.102 H 56.099 V 0 H 0 Z"
         id="path14" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath44"><path
         d="M 1.95996,54.0659 H 54.4014 V 1.625 H 1.95996 Z"
         id="path42" /></clipPath></defs><sodipodi:namedview
     id="namedview4"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     inkscape:zoom="11.283"
     inkscape:cx="37.401402"
     inkscape:cy="37.445716"
     inkscape:window-width="1848"
     inkscape:window-height="1016"
     inkscape:window-x="72"
     inkscape:window-y="27"
     inkscape:window-maximized="1"
     inkscape:current-layer="g8" />
     <g v-if="isHover"
     id="g8"
     inkscape:groupmode="layer"
     inkscape:label="filter_mouse over"
     transform="matrix(1.3333333,0,0,-1.3333333,0,74.8028)"><g
       id="g10"><g
         id="g12"
         clip-path="url(#clipPath16)"><g
           id="g18"
           transform="translate(43.5913,10.0283)"><path
             d="m 0,0 c -1.879,1.804 -5.355,5.071 -7.577,6.896 -2.127,1.748 -6.702,4.827 -8.137,5.968 -2.194,-1.365 -4.835,-2.048 -7.603,-1.758 -6.618,0.694 -11.421,6.622 -10.729,13.238 0.693,6.615 6.618,11.421 13.236,10.726 6.617,-0.69 11.419,-6.618 10.729,-13.235 -0.214,-2.044 -0.931,-3.915 -2.012,-5.505 1.442,-1.293 5.428,-5.076 7.489,-6.769 2.416,-1.986 5.807,-4.207 8.002,-5.943 z m -20.512,37.317 c -11,0.333 -17.333,-7.001 -15.833,-17.584 0.828,-5.845 7.166,-10.833 13.583,-11 3.906,-0.101 7.667,2.333 9.166,1.25 2.812,-2.03 10.842,-9.206 12.75,-10.75 1.75,-1.416 6.167,4.333 5,5.25 -1.875,1.473 -10.583,8.833 -12.75,10.75 -1.235,1.093 2.334,6 0.917,11.25 -1.838,6.811 -8.135,10.692 -12.833,10.834"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path20" /></g><g
           id="g22"
           transform="translate(31.1997,26.623)"><path
             d="m 0,0 c 0.08,-0.069 0.185,-0.161 0.299,-0.265 1.081,1.59 1.798,3.461 2.012,5.506 0.69,6.616 -4.113,12.545 -10.729,13.234 -6.619,0.695 -12.543,-4.111 -13.236,-10.726 -0.693,-6.616 4.111,-12.544 10.728,-13.237 2.768,-0.29 5.409,0.392 7.603,1.758 -0.081,0.065 -0.157,0.126 -0.218,0.178 z"
             style="fill:none;stroke:#000000;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path24" /></g><g
           id="g26"
           transform="translate(31.1997,26.623)"><path
             d="m 0,0 c 0.08,-0.069 0.185,-0.161 0.299,-0.265 1.081,1.59 1.798,3.461 2.012,5.506 0.69,6.616 -4.113,12.545 -10.729,13.234 -6.619,0.695 -12.543,-4.111 -13.236,-10.726 -0.693,-6.616 4.111,-12.544 10.728,-13.237 2.768,-0.29 5.409,0.392 7.603,1.758 -0.081,0.065 -0.157,0.126 -0.218,0.178 z"
             style="fill:none;stroke:#ffffff;stroke-width:0.4;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path28" /></g><g
           id="g30"
           transform="translate(38.9878,19.5889)"><path
             d="m 0,0 c -2.062,1.693 -6.048,5.477 -7.489,6.77 -0.952,-1.403 -2.193,-2.577 -3.622,-3.466 1.436,-1.142 6.01,-4.221 8.137,-5.968 2.222,-1.825 5.699,-5.093 7.578,-6.897 l 3.398,3.619 C 5.807,-4.206 2.415,-1.985 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path32" /></g><g
           id="g34"
           transform="translate(31.4985,26.3584)"><path
             d="M 0,0 C -0.114,0.104 -0.219,0.195 -0.299,0.265 L -3.84,-3.287 c 0.061,-0.052 0.137,-0.113 0.218,-0.179 1.43,0.89 2.67,2.064 3.622,3.466"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path36" /></g><g
           id="g38"
           transform="translate(30.4614,24.2207)"><path
             d="M 0,0 C 2.931,-2.602 10.874,-8.772 13.776,-11.656"
             style="fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path40" /></g><g
           id="g42"
           transform="translate(13.8115,38.4707)"><path
             d="m 0,0 c 0.256,0.258 -1.928,-4.117 -0.54,-7.896 1.812,-4.928 5.386,-6.2 5.069,-6.136 -0.814,0.161 -3.308,0.854 -5.368,4.628 C -3.542,-4.461 -0.519,-0.521 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path44" /></g><g
           id="g46"><g
             id="g48" /><g
             id="g60"><g
               clip-path="url(#clipPath52)"
               opacity="0"
               id="g58"><g
                 transform="translate(53.5112,2.7998)"
                 id="g56"><path
                   d="m 0,0 c 0,-0.418 -0.283,-0.756 -0.636,-0.756 h -51.17 c -0.352,0 -0.635,0.338 -0.635,0.756 v 50.93 c 0,0.417 0.283,0.756 0.635,0.756 h 51.17 C -0.283,51.686 0,51.347 0,50.93 Z"
                   style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
                   id="path54" /></g></g></g></g><g
           id="g62"
           transform="translate(53.5112,2.7998)"><path
             d="m 0,0 c 0,-0.418 -0.283,-0.756 -0.636,-0.756 h -51.17 c -0.352,0 -0.635,0.338 -0.635,0.756 v 50.93 c 0,0.417 0.283,0.756 0.635,0.756 h 51.17 C -0.283,51.686 0,51.347 0,50.93 Z"
             style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path64" /></g></g></g></g>
    <g v-else
     id="g8"
     inkscape:groupmode="layer"
     inkscape:label="filter_button"
     transform="matrix(1.3333333,0,0,-1.3333333,0,74.8028)"><g
       id="g10"><g
         id="g12"
         clip-path="url(#clipPath16)"><g
           id="g18"
           transform="translate(33.5103,31.8638)"><path
             d="m 0,0 c -0.693,-6.616 -6.62,-11.421 -13.236,-10.729 -6.618,0.693 -11.421,6.621 -10.729,13.237 0.693,6.616 6.618,11.422 13.236,10.726 C -4.112,12.545 0.69,6.616 0,0"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path20" /></g><g
           id="g22"
           transform="translate(33.5103,31.8638)"><path
             d="m 0,0 c -0.693,-6.616 -6.62,-11.421 -13.236,-10.729 -6.618,0.693 -11.421,6.621 -10.729,13.237 0.693,6.616 6.618,11.422 13.236,10.726 C -4.112,12.545 0.69,6.616 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path24" /></g><g
           id="g26"
           transform="translate(33.5103,31.8638)"><path
             d="m 0,0 c -0.693,-6.616 -6.62,-11.421 -13.236,-10.729 -6.618,0.693 -11.421,6.621 -10.729,13.237 0.693,6.616 6.618,11.422 13.236,10.726 C -4.112,12.545 0.69,6.616 0,0 Z"
             style="fill:none;stroke:#ffffff;stroke-width:0.4;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path28" /></g><g
           id="g30"
           transform="translate(43.5913,10.0283)"><path
             d="m 0,0 c -1.879,1.804 -5.355,5.071 -7.577,6.896 -2.248,1.847 -7.236,5.185 -8.356,6.147 l 3.541,3.552 C -11.307,15.661 -6.83,11.39 -4.604,9.561 -2.188,7.575 1.203,5.354 3.398,3.618 Z"
             style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path32" /></g><g
           id="g34"
           transform="translate(30.4614,24.2207)"><path
             d="M 0,0 C 2.931,-2.602 10.874,-8.772 13.776,-11.656"
             style="fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path36" /></g><g
           id="g38"
           transform="translate(13.8115,38.4707)"><path
             d="m 0,0 c 0.256,0.258 -1.928,-4.117 -0.54,-7.896 1.812,-4.928 5.386,-6.2 5.069,-6.136 -0.814,0.161 -3.308,0.854 -5.368,4.628 C -3.542,-4.461 -0.519,-0.521 0,0"
             style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path40" /></g><g
           id="g42"><g
             id="g44" /><g
             id="g56"><g
               clip-path="url(#clipPath48)"
               opacity="0"
               id="g54"><g
                 transform="translate(53.5112,2.7998)"
                 id="g52"><path
                   d="m 0,0 c 0,-0.418 -0.283,-0.756 -0.636,-0.756 h -51.17 c -0.352,0 -0.635,0.338 -0.635,0.756 v 50.93 c 0,0.417 0.283,0.756 0.635,0.756 h 51.17 C -0.283,51.686 0,51.347 0,50.93 Z"
                   style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
                   id="path50" /></g></g></g></g><g
           id="g58"
           transform="translate(53.5112,2.7998)"><path
             d="m 0,0 c 0,-0.418 -0.283,-0.756 -0.636,-0.756 h -51.17 c -0.352,0 -0.635,0.338 -0.635,0.756 v 50.93 c 0,0.417 0.283,0.756 0.635,0.756 h 51.17 C -0.283,51.686 0,51.347 0,50.93 Z"
             style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path60" /></g></g></g></g>
    <title
      :id="iconName"
      lang="en"
    >General Search</title>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 56
    },
    height: {
      type: [Number, String],
      default: 56
    },
    iconColor: {
      type: String,
      default: '#84bd9f'
    }
  },
  data () {
    return {
      isHover:false,
    }
  }
}
</script>